import { cn } from "@/lib/utils"

function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      className={cn("bg-accent animate-pulse rounded-md", className)}
      {...props}
    />
  )
}

export { Skeleton }

// Additional specialized skeleton components for streaming SSR
export const ContentSkeleton = () => (
  <div className="space-y-4 animate-pulse">
    <div className="space-y-2">
      <Skeleton className="h-4 w-3/4" />
      <Skeleton className="h-4 w-1/2" />
    </div>
    <div className="space-y-2">
      <Skeleton className="h-4 w-5/6" />
      <Skeleton className="h-4 w-4/5" />
      <Skeleton className="h-4 w-2/3" />
    </div>
    <div className="space-y-2">
      <Skeleton className="h-4 w-3/4" />
      <Skeleton className="h-4 w-1/2" />
    </div>
  </div>
);

export const NavigationSkeleton = () => (
  <div className="space-y-3 p-2">
    {Array.from({ length: 8 }, (_, i) => (
      <div key={i} className={`flex items-center space-x-2 ${i % 3 === 1 ? 'pl-5' : 'pl-0'}`}>
        <Skeleton className="h-4 w-4 rounded-md flex-shrink-0" />
        <Skeleton className={`h-2 ${['w-11/12', 'w-5/6', 'w-3/4', 'w-4/5'][i % 4]} rounded-md`} />
      </div>
    ))}
  </div>
);

export const TiptapSkeleton = () => (
  <div className="space-y-6 animate-pulse">
    <div className="space-y-3">
      <Skeleton className="h-6 w-2/3" />
      <div className="space-y-2">
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-5/6" />
        <Skeleton className="h-4 w-4/5" />
      </div>
    </div>
    <div className="space-y-3">
      <Skeleton className="h-6 w-1/2" />
      <div className="space-y-2">
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-3/4" />
      </div>
    </div>
    <Skeleton className="h-32 w-full rounded-lg" />
    <div className="space-y-2">
      <Skeleton className="h-4 w-full" />
      <Skeleton className="h-4 w-2/3" />
    </div>
  </div>
);
